__webpack_require__.p = "https://ui.beta.us-west-2.urc.advertising.amazon.dev/";